export default __webpack_public_path__ + "static/cta-do-d047f30db630651182810a75dfe35732c512c0a3fb8aa6a460d67b441f5bb4f8.png";